import { Component, Input, OnInit, inject, output, signal } from '@angular/core';

import { AnchorDirective, CurrencyPipe, DynamicHtmlDirective, NavigationService } from '@frontend/vanilla/core';
import { AffordabilityService } from '@frontend/vanilla/features/affordability';
import { TranslateModule } from '@ngx-translate/core';

import { UrlConstants } from '../../../config/urlConstants';
import { MessageType } from '../../../model/message.model';
import { DataService } from '../../../service/data.service';
import { DepositService } from '../../../service/deposit.service';
import { GtmService } from '../../../service/gtm.service';
import { QdApiService } from '../../../service/qd.service';
import { ResizeService } from '../../../service/resize.service';
import { UserDataService } from '../../../service/userDataService';
import { MessageComponent } from '../../../shared/components/messages/message-component';
import { ADAMessageComponent } from './ada-message/ada-message.component';
import { ARCMessageComponent } from './arc-message/arc-message.component';
import { PLVerificationMessageComponent } from './pl-verification-message/pl-verification-message.component';
import { PlayBreakMessageComponent } from './play-break-message/play-break-message.component';
import { ReversalNotificationComponent } from './reversal-notification/reversal-notification.component';
import { SessionLimitsComponent } from './session-limits/session-limits.component';

@Component({
    selector: 'app-additional-messages',
    templateUrl: 'additional-messages.component.html',
    imports: [
        ADAMessageComponent,
        PlayBreakMessageComponent,
        ARCMessageComponent,
        PLVerificationMessageComponent,
        ReversalNotificationComponent,
        SessionLimitsComponent,
        MessageComponent,
        TranslateModule,
        AnchorDirective,
        DynamicHtmlDirective,
        CurrencyPipe,
    ],
})
export class AdditionalMessagesComponent implements OnInit {
    private gtmService = inject(GtmService);
    private userDataService = inject(UserDataService);
    private dataService = inject(DataService);
    private apiService = inject(QdApiService);
    depositService = inject(DepositService);
    private resizeService = inject(ResizeService);
    private affordabilityService = inject(AffordabilityService);
    private currencyPipe = inject(CurrencyPipe);

    messageType = MessageType;
    private navigationService = inject(NavigationService);
    activeDepositCurfewInfo = output<boolean>();
    isEsRiskPlayer: boolean;
    @Input() selectedOption: { paymentAccountInfo: { isESRiskPlayer: string } };
    liveChatRiskPlayerUrl: string;
    activeDepositCurfew: boolean;
    depositCurfewRedirectUrl: string;
    showVATInfoMessage = signal<boolean>(false);
    userData: any;
    esExpIdBannerName: string;
    esExpIdPositionEvnt: string;
    showMLLinterceptor: boolean;
    tuRefreshMllBanner: string;
    mllLimitType: string;
    affordabilityLevel: string;
    affEmploymentGroup: string;
    affAgeGroup: string;
    ngOnInit() {
        const lang = this.dataService?.sessionInfo?.langId ?? 'en';
        this.liveChatRiskPlayerUrl = `${this.userDataService?.userData?.configParams?.merchant_hostname}/${lang}${UrlConstants.LIVE_CHAT_ES_LINK}`;
        this.userData = this.userDataService?.userData;
        this.isEsRiskPlayer = this.selectedOption?.paymentAccountInfo?.isESRiskPlayer == 'Y';
        if (this.isEsRiskPlayer) {
            this.gtmService.riskyPlayerAccountTempBlock();
        }
        this.getDepositCurfewDetails();
        this.depositService.showVATTaxMessage.set(
            this.userData?.configParams?.colombia_deposit_tax_enabled == 'Y' && this.userData?.configParams?.colombia_tax_message_closed == 'N',
        );
        this.showVATInfoMessage.set(
            this.userData?.configParams?.colombia_deposit_tax_enabled == 'Y' &&
                Number(this.userData?.configParams?.colombia_success_deposit_count) >=
                    Number(this.userData?.configParams?.colombia_deposit_threshold_count),
        );
        if (
            this.userData?.configParams?.isSpainExpiryKycRefreshCheckEnabled == 'Y' &&
            ['600', '602'].includes(this.userData?.configParams?.rekycSubErrorCode)
        ) {
            this.esExpIdBannerName = 'avoid account restrictions banner';
            this.esExpIdPositionEvnt = this.userData?.configParams?.rekycSubErrorCode == '600' ? 'verification pending' : 'verification pending id';
            this.gtmService.raiseEventForEsExpIdKycLoad(this.esExpIdBannerName, this.esExpIdPositionEvnt);
        }
        this.showMLLinterceptor =
            this.userData?.configParams?.tuRefreshMllFlagStatus?.toLowerCase() == 'pending' && this.userData?.configParams?.limitType;
        if (this.showMLLinterceptor) {
            this.depositService.isFormDisable.set(this.showMLLinterceptor);
            this.mllLimitType = this.userData.configParams?.limitType?.toLowerCase() == 'calendar' ? 'calendar month' : 'r30';
            this.affordabilityService.getSnapshotDetails().subscribe((data) => {
                this.affordabilityLevel = data?.affordabilityStatus;
                this.affEmploymentGroup = data?.employmentGroup;
                this.affAgeGroup = data?.ageGroup;
                this.tuRefreshMllBanner = `max loss limit tu refresh - ${this.currencyPipe.transform(this.userData.configParams?.limit, '')} new limit  banner`;
                this.gtmService.raiseEventForaffordabilityMsgsLoadandClick(
                    'deposit process',
                    'load',
                    this.tuRefreshMllBanner,
                    this.tuRefreshMllBanner,
                    'not applicable',
                    this.affordabilityLevel,
                    this.affEmploymentGroup,
                    this.affAgeGroup,
                    this.mllLimitType,
                );
            });
        }
    }
    liveChatUrlRisky() {
        this.gtmService.riskyPlayerClickOnLiveChat('account restricted message', this.liveChatRiskPlayerUrl);
        this.navigationService.goTo(this.liveChatRiskPlayerUrl, { forceReloadTarget: 'top' });
    }
    getDepositCurfewDetails() {
        this.apiService.get(UrlConstants.DEPOSIT_CURFEW_DETAILS_URI).subscribe((response) => {
            if (response && response?.inDepositCurfew) {
                this.activeDepositCurfew = response?.inDepositCurfew;
                this.activeDepositCurfewInfo.emit(!!this.activeDepositCurfew);
                this.depositCurfewRedirectUrl = response?.depositCurfewUrl?.url;
            }
        });
    }
    closeToaster() {
        this.depositService.closeVATTaxMessage().then((data) => {
            if (data == 0) {
                this.depositService.showVATTaxMessage.set(false);
                this.resizeService.resizeCashier();
            }
        });
    }
    updateNowCta() {
        this.gtmService.raiseEventForEsExpIdKycClick(
            this.esExpIdBannerName + ' - update now cta',
            this.userData?.configParams?.rekycUrl + '&cashierQd=true',
            this.esExpIdPositionEvnt,
        );
    }
    mllInterceptorClick(val: boolean) {
        const ctaName = val ? 'keep limit' : 'set limit';
        this.gtmService.raiseEventForaffordabilityMsgsLoadandClick(
            'deposit process',
            'click',
            this.tuRefreshMllBanner,
            ctaName + ' cta',
            this.userData?.configParams?.limitUrl,
            this.affordabilityLevel,
            this.affEmploymentGroup,
            this.affAgeGroup,
            this.mllLimitType,
        );
        const reqObj = {
            flag: 'tu_mll',
            dnaId: this.userData?.configParams?.dnaId,
            status: 'completed',
            consent: ctaName,
            dnaIdInfo: {},
        };
        this.depositService.updateDnaConfig(reqObj).then(() => {
            if (val) {
                this.showMLLinterceptor = false;
                this.depositService.isFormDisable.set(false);
                this.resizeService.resizeCashier();
            }
        });
    }
}
